import { Field } from "react-final-form";
import { formatters } from "common/FormUtils";
import TextField from "./TextField";

export default function DecimalNumberField({ input, decimalPlaces, ...rest }) {
    return (
        <Field {...input} {...rest} format={formatters.formatDecimal(decimalPlaces)} formatOnBlur type="number" component={TextField} />
    );
}
